import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, Tooltip } from "antd";
import styles from "./common.module.scss";

type Props = {
  selected: string | null;
  setSelected: (arg: any) => void;
  label?: string;
  items?: any;
};

const DropdownButton: React.FC<Props> = ({
  items,
  label = "Button",
  selected = null,
  setSelected,
}) => {
  const noOptions = !items || items.length === 0;

  const menuProps: any = {
    items: (items || []).map((item: any) => ({
      ...item,
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          <span>{item.label}</span>
          {selected === item.key && <FontAwesomeIcon icon={faCheck} />}
        </div>
      ),
    })),
    selectedKeys: [selected],
    onClick: ({ key }: any) => {
      setSelected(key === selected ? null : key);
    },
  };

  const getSelectedValue = () => {
    const match = items.find((f: any) => f.key === selected);
    return match?.label;
  };

  return (
    <Tooltip
      title={
        noOptions
          ? "No options available based on your current selections"
          : undefined
      }
      placement="top"
    >
      <span style={{ display: "inline-block" }}>
        <Dropdown
          menu={menuProps}
          trigger={["click"]}
          rootClassName={styles.dropdownMenu}
          disabled={noOptions}
        >
          <Button
            className={styles.dropdownButton}
            icon={<FontAwesomeIcon icon={faChevronDown} />}
            iconPlacement="end"
            variant="outlined"
            disabled={noOptions}
            style={{
              width: "fit-content",
              padding: "6px 8px 6px 10px",
              opacity: noOptions ? 0.3 : undefined,
              pointerEvents: noOptions ? "none" : undefined,
            }}
            color="default"
          >
            {selected ? getSelectedValue() : label}
          </Button>
        </Dropdown>
      </span>
    </Tooltip>
  );
};

export default DropdownButton;
